module.exports = __webpack_public_path__ + "assets/img/thumb-National-Media-Video.5e097e00.webp";